import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { RouterProvider } from 'react-router';
import { queryClient } from './api/queryClient';
import { DialogProvider } from './components/dialogs/DialogProvider';
import { ToastProvider } from './components/Toast';
import { UnsavedProvider } from './components/unsaved/unsaved';
import { router } from './routes';
import { colours, theme } from './theme';

const globals = (
  <GlobalStyles
    styles={{
      // Keyboard users can jump past the sidebar.
      '.skip-link': { position: 'absolute', left: -9999, top: 8, zIndex: 2000, padding: '8px 16px', background: colours.nearBlack, color: colours.white, borderRadius: 8 },
      '.skip-link:focus': { left: 8 },
    }}
  />
);

/** Everything around the pages: theme, data, dialogs and toasts. Tests reuse it. */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globals}
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <UnsavedProvider>
            <DialogProvider>{children}</DialogProvider>
          </UnsavedProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
